<template>
  <td :aria-label="theTitle" :class="theClass" :style="theStyle">
    <template
      v-if="
        statistic.statisticDefinition.ci &&
        statistic.value !== undefined &&
        !statistic.isSampleSizeIsTooLow &&
        !statistic.isRelativeStandardErrorTooHigh &&
        !statistic.isMissing
      "
    >
      {{ statistic.formattedCi }}
    </template>
  </td>
</template>
<script>
/* eslint no-unused-vars: 'off' */
import reportModelBuilder from "@/scripts/crossTabulation/reportModelBuilder";
export default {
  props: ["statistic"],
  data: function () {
    var vm = this;
    return {
      theClass: vm.statistic.isRowTotal ? "row-total" : "statistic-cell",
      theStyle:
        vm.statistic.formattedCi.length > 16 ? "white-space: inherit;" : "",
      theTitle: reportModelBuilder.getCiTitle(vm.statistic.apiName),
    };
  },
  methods: {
    // formatCi: function (value, name) {
    //   var vm = this;
    //   if (name === 'weightedN')
    //     return common.formatNumber(value, 0);
    //   else
    //     return vm.formatConfidenceInterval(value, 1);
    // },
    // formatConfidenceInterval: function (value, decimalPlaces) {
    //   var range = common.getRange(value);
    //   if (range === null)
    //     return value;
    //   else
    //     return '(' + common.formatNumber(range[0], decimalPlaces) + ' - ' + common.formatNumber(range[1], decimalPlaces) + ')';
    // }
  },
};
</script>

<style scoped>
div.statistic-row {
  margin: 0 4px 0 4px;
  white-space: nowrap;
}

td {
  /*display:inline-block;*/
  /*float:left;*/
  /*margin-left: 10px;*/
  padding: 0 2px 0 4px;
  /*background-color: ghostwhite;*/
  margin: 2px 4px 2px 8px;
  text-align: center;
  width: 96px;
}
</style>
